var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6854 0.858195C15.9886 -0.0549684 17.2803 -0.0549699 17.5835 0.858194L20.7663 10.4438C20.9021 10.8527 21.2845 11.1287 21.7154 11.1287H31.9684C32.9424 11.1287 33.3416 12.3793 32.5478 12.9437L24.2906 18.8142C23.9325 19.0688 23.7825 19.5274 23.921 19.9444L27.0837 29.4695C27.3884 30.387 26.3432 31.1598 25.5552 30.5996L17.2139 24.6693C16.867 24.4227 16.4019 24.4227 16.055 24.6693L7.71365 30.5996C6.92572 31.1598 5.8805 30.387 6.18516 29.4695L9.34792 19.9444C9.48639 19.5274 9.33642 19.0688 8.97831 18.8142L0.721036 12.9437C-0.0727651 12.3793 0.326502 11.1287 1.30047 11.1287H11.5535C11.9843 11.1287 12.3668 10.8527 12.5025 10.4438L15.6854 0.858195Z",
    fill: "#09A5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/starFilled.7153d79e8dbf94047b5c867c157848b0.svg";
export { ForwardRef as ReactComponent };